exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".secondary-highlighted-line{background:green}.primary-highlighted-line{background:blue}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-40c4224a!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 45
// module chunks = 0